import React from "react";
import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/lib/constants";

const Process = () => {
  return (
    <section id="ablauf" data-testid="process-section" className="py-24 lg:py-32 bg-[#F8FAFC] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#E6F6F8] rounded-full blur-3xl opacity-60 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#1FA3B5] mb-4">So funktioniert's</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
            In drei Schritten zu Ihrem
            <span className="text-[#1FA3B5]"> entspannten</span> Autotermin.
          </h2>
        </motion.div>

        <div className="mt-16 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Steps */}
          <div className="lg:col-span-7 space-y-6 lg:space-y-8">
            {PROCESS_STEPS.map((p, i) => (
              <motion.div
                key={p.step}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`process-step-${p.step}`}
                className="relative flex gap-6 lg:gap-8 bg-white rounded-3xl p-6 lg:p-8 border border-slate-100 hover:shadow-xl hover:shadow-slate-900/5 transition-all"
              >
                <div className="flex-shrink-0">
                  <div className="font-heading text-5xl lg:text-6xl font-bold text-[#1FA3B5]/15 leading-none">
                    {p.step}
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-xl lg:text-2xl font-semibold text-slate-900">{p.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 lg:sticky lg:top-28"
          >
            <div className="rounded-3xl overflow-hidden shadow-2xl shadow-slate-900/10 border border-slate-100">
              <img
                src="https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&w=1200&q=80"
                alt="Mercedes-Benz Schlüsselübergabe"
                className="w-full h-[480px] object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Process;
